import styled, { css } from 'styled-components'

import { FlexContainer } from '../flexContainer'

type HeaderContainerProps = {
  backgroundColor?: string
  backdropFilter?: string
  shrinked?: boolean
  ref?: any
  id?: string
  hasTranslation?: boolean
}

const transition = 'all 0.4s ease-in-out;'

export const FlexContainerHeader = styled(FlexContainer)<HeaderContainerProps>`
  padding: 0;
  width: 100%;
  max-width: 100vw;
  justify-content: center;
  position: fixed;
  top: 0;
  align-items: center;
  z-index: 101;

  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor || `${theme.colors.black}72`};
  backdrop-filter: ${({ backdropFilter }) => backdropFilter || 'blur(10px)'};

  @media (max-width: 1180px) {
    padding: 0 16px !important;
  }
`
export const HeaderContainer = styled.div<HeaderContainerProps>`
  transition: ${transition};

  display: flex;
  align-items: center;
  justify-content: ${({ hasTranslation }) =>
    hasTranslation ? 'space-between' : 'center'};

  width: 100%;
  height: 100%;
  max-width: 1170px;

  padding: 32px 0;

  ${(props) =>
    props.shrinked
      ? `
    margin-top: -0.5em;
    padding: 16px 0;
 `
      : ''};

  .images {
    margin-left: ${({ hasTranslation }) => (hasTranslation ? '41%' : '0')};
    img {
      width: auto;
      object-fit: contain;
      height: 42px;
      transition: height 0.5s ease-in-out;
    }

    @media (max-width: 800px) {
      img {
        height: 32px;
      }
    }
    @media (max-width: 550px) {
      img {
        height: 22px;
      }
    }
    @media (max-width: 450px) {
      img {
        height: 14px;
      }
    }

    ${({ shrinked }) => {
      if (shrinked) {
        return css`
          img {
            height: 32px;
          }

          @media (max-width: 800px) {
            img {
              height: 22px;
            }
          }
          @media (max-width: 450px) {
            img {
              height: 14px;
            }
          }
        `
      }
      return ''
    }}

    transition: ${transition};

    @media (max-height: 768px) {
      height: calc(42px * 0.8);
    }

    @media (max-width: 768px) {
      height: 32px;
    }

    @media (max-width: 375px) {
      height: 24px;
    }

    @media (max-width: 320px) {
      height: 16px;
    }
  }

  .language-switch {
    @media (max-width: 800px) {
      scale: 0.9;
    }
    @media (max-width: 550px) {
      scale: 0.8;
    }
    @media (max-width: 450px) {
      scale: 0.6;
    }
  }
`
